import { ValueTypes } from "constants/product-collection";

export enum LookupKind {
    DefaultKind = "DEFAULT_KIND",
    SIZE_DISTRIBUTION = "SIZE_DISTRIBUTION",
    SIZES = "SIZES",
    SIZE_ORDER = "SIZE_ORDER",
    SIZE_RANGE = "SIZE_RANGE",
    PERCENT_DISTRIBUTION = "PERCENT_DISTRIBUTION",
    DOOR_NUMBER = "DOOR_NUMBER",
}

export interface ILookupColumn {
    table_column: string;
    schema_column?: string;
    enforced_value?: string;
    kind: LookupKind;
}

export interface ILookupWhereField {
    column: ILookupColumn;
    is_required?: boolean;
}

export interface ILookupWhere {
    fields: ILookupWhereField[];
    fallback?: ILookupWhere;
}

export interface ILookupTerm {
    column: ILookupColumn;
    string_aggr?: {
        delimiter?: string;
    };
    combined_display?: ICombinedDisplay;
}

export interface ICombinedDisplay {
    columns: ILookupColumn[];
    delimiter: string;
}

export interface ILookupOrder {
    column: string;
    sort: {
        order: "ASC" | "DESC";
    };
}

export interface ILookupSelect {
    terms: ILookupTerm[];
}

export interface ILookup {
    auto_select_single_result: boolean;
    select: ILookupSelect;
    from: {
        database_name: string;
        table_name: string;
    };
    where: ILookupWhere;
    group_by?: {
        columns: ILookupColumn[];
    };
    order?: {
        by: ILookupOrder[];
    };
    returnKeyValue?: boolean;
    display?: {
        format: string;
        dropdown_format?: string;
    };
}

export enum ILookupFieldType {
    INT64 = "INT64",
    STRING = "STRING",
}

export interface ILookupRawData {
    row: ILookupRowItem;
    key: string;
    format: string;
    value: string;
}
export interface ILookupRowItem {
    [key: string]: ILookupRowObject;
}

export type ILookupRowObject = (ILookupRowInt64Value | ILookupRowStringValue) & {
    rawValue: string | number;
    value: Array<number | string>;
    schemaName: string;
};

export interface ILookupRowInt64Value {
    type: ILookupFieldType.INT64;
    int64_value: number;
}
export interface ILookupRowStringValue {
    type: ILookupFieldType.STRING;
    string_value: string;
}

export interface ILookupFromType {
    database_name: string;
    table_name: string;
}

export interface ILookupResponseRowValue {
    int64_value?: {
        value: number;
    };
    string_value?: {
        value: string;
    };
}

export interface ILookupFormattedRow {
    selectColumns: {
        [field: string]: string | number;
    };
    value: {
        raw: string | number;
        formatted: string;
        dropdownFormatted: string;
    };
}

// TODO: Add types
export interface IExecuteSqlStatement {
    select_clause: any;
    where_clause: any;
    group_by: any;
    order: any;
    limit: any;
    offset: any;
}

export interface IDependency {
    [propName: string]: string;
}

export interface IValueTypeMap {
    [field: string]: {
        value: string;
        type: ValueTypes;
    };
}
